import { render, staticRenderFns } from "./LegacyPackageImportModal.vue?vue&type=template&id=93989a0a"
import script from "./LegacyPackageImportModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegacyPackageImportModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93989a0a')) {
      api.createRecord('93989a0a', component.options)
    } else {
      api.reload('93989a0a', component.options)
    }
    module.hot.accept("./LegacyPackageImportModal.vue?vue&type=template&id=93989a0a", function () {
      api.rerender('93989a0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/LegacyPackageImportModal.vue"
export default component.exports